import { IUserTicketData } from 'meta/pages/v4/ticket'
import { useAppSelector } from 'store'
import { TicketSelectors } from 'store/pages/ticket'

export const useUserTicketData = ({ cod }: { cod: string }): IUserTicketData | undefined =>
  useAppSelector(TicketSelectors.getUserTicketData({ cod }))

export const useTypeTicketsIdsForGivenEvent = ({ eventId }: { eventId: number }): number[] | undefined =>
  useAppSelector(TicketSelectors.getUserTypeTicketIdsForGivenEvent({ eventId }))
